export default __webpack_public_path__ + "static/media/prev-Marine-Receiver-4.3465c26a.png";